import {
    NinchatActionType,
    NinchatCreateIdentityAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createIdentity = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateIdentityAction}`,
    async (arg: NinchatActionParams<NinchatCreateIdentityAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateIdentityAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
